import { Injectable } from "@angular/core";

import { Enquiry } from "./model/api/enquiry";

@Injectable()
export class EnquiryService {
    formEnquiry: Enquiry;
    submitted = false;
}
